import BaseComponent from "../BaseComponent";
import React from "react";
import PropTypes from "prop-types";
import GF from "../../utils/GF";
import Button from "@mui/material/Button";

class SelectableItem extends BaseComponent {

  render() {
    return <Button
      variant='outlined'
      color='secondary'
      className={'selectoItem'}
      sx={{textTransform: 'none'}}
      id={this.props.elementId}
      data-element-active={this.props.active}
      data-element-id={GF.getValue(this.props.elementId, '')}>
      {this.props.children}
    </Button>;
  }
}

SelectableItem.propTypes = {
  elementId: PropTypes.string, active: PropTypes.bool, className: PropTypes.string
}
export default SelectableItem;
